export default {
  purchase: undefined,
  purchases: [],
};
